import { C as o } from "./cookieSetting-8ba5aff4.mjs";
import { jsxs as t, jsx as e } from "react/jsx-runtime";
import { c as m } from "./themes-5f0b3c3d.mjs";
import * as n from "react";
import { Tabs as f, Tab as y, TabPanels as g } from "./tabs.js";
import { Switch as b } from "./switch.js";
import { Button as k } from "./button.js";
import "./modalMixedStructure.modalWindow-3bb1e4ef.mjs";
import "react-dom";
import "./index-6a632112.mjs";
import "./lineHeights-72d3110c.mjs";
import "./zIndices-d07533f3.mjs";
import "./closeButton.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./index-c8707610.mjs";
import "./tslib.es6-59e1c9d8.mjs";
import "./superScript-393c70dc.mjs";
import "./disclosure.js";
import "./hTag-40b23797.mjs";
import "./badge.js";
import "./checkmark-84b5274e.mjs";
function J() {
  const [s, a] = n.useState(!1), [c, l] = n.useState({
    first: !0,
    second: !1,
    third: !1
  }), [d, p] = n.useState(0), i = [
    { id: "1", label: "Cookie Details" },
    { id: "2", label: "Strictly Necessary Cookies" },
    { id: "3", label: "Non-essential Cookies" }
  ];
  return /* @__PURE__ */ t(
    "div",
    {
      style: {
        display: "flex",
        padding: "2vw",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-around"
      },
      children: [
        /* @__PURE__ */ e("div", { children: /* @__PURE__ */ e(k, { onClick: () => a(!0), children: "Open Cookie Setting" }) }),
        /* @__PURE__ */ e(
          o,
          {
            openCookieSettings: s,
            closeCookieSettigs: () => {
              a(!s);
            },
            children: /* @__PURE__ */ e(o.Container, { children: i && /* @__PURE__ */ t(
              f,
              {
                activeTab: d,
                setActiveTab: p,
                size: "small",
                children: [
                  /* @__PURE__ */ e(
                    o.TabList,
                    {
                      style: {
                        borderBottom: `1px solid ${m.brandTwilight[400]}`
                      },
                      children: i && i.map(({ id: r, label: h }, u) => /* @__PURE__ */ e(y, { index: u, children: h }, r))
                    }
                  ),
                  /* @__PURE__ */ t(g, { children: [
                    /* @__PURE__ */ t(o.TabPanel, { children: [
                      /* @__PURE__ */ e(o.ContentHeader, { children: i[0].label }),
                      /* @__PURE__ */ e("div", { children: "When you visit our website, we store cookies on your browser to collect information. The information collected might relate to you, your preferences, or your device and is mostly used to make the site work as you expect it to and to provide a more personalized web experience. However, you can choose not to allow certain types of cookies, which may impact your experience of the site and the services we are able to offer. Click on the different category headings to find out more and change your default settings according to your preference. You cannot opt-out of our Strictly Necessary cookies as they are deployed in order to ensure the proper functioning of our website (such as prompting the cookie banner and remembering your settings, to log into your account, to redirect you when you log out, etc.). For more information about the cookies we use, please click the links at the left." })
                    ] }),
                    /* @__PURE__ */ t(o.TabPanel, { children: [
                      /* @__PURE__ */ e(o.ContentHeader, { children: i[1].label }),
                      /* @__PURE__ */ e(o.ContentBody, { children: "These cookies are necessary for the website to function and cannot be switched off. They are usually only set in response to actions made by you which amount to a request for services, such as setting your privacy preferences, logging in or filling in forms. You can set your browser to block or alert you about these cookies, but some parts of the site will not then work." })
                    ] }),
                    /* @__PURE__ */ t(o.TabPanel, { children: [
                      /* @__PURE__ */ t(o.ContentHeader, { children: [
                        i[2].label,
                        /* @__PURE__ */ e(
                          b,
                          {
                            isChecked: c.first,
                            onChange: () => {
                              l((r) => ({
                                ...r,
                                first: !r.first
                              }));
                            }
                          }
                        )
                      ] }),
                      "These are cookies that are not essential for the operation of the website.",
                      /* @__PURE__ */ t("div", { children: [
                        /* @__PURE__ */ e(
                          o.ContentHeader,
                          {
                            style: { padding: "24px 0 0 24px" },
                            children: "Performance Cookies"
                          }
                        ),
                        /* @__PURE__ */ e(
                          o.ContentBody,
                          {
                            style: { padding: "8px 0 0 24px" },
                            children: "These cookies allow us to count visits and traffic sources so we can measure and improve the performance of our site. They help us to know which pages are the most and least popular and see how visitors move around the site."
                          }
                        ),
                        /* @__PURE__ */ e(
                          o.ContentHeader,
                          {
                            style: { padding: "24px 0 0 24px" },
                            children: "Targeting Cookies"
                          }
                        ),
                        /* @__PURE__ */ e(
                          o.ContentBody,
                          {
                            style: { padding: "8px 0 0 24px" },
                            children: "These cookies may be set through our site by our advertising partners. They may be used by those companies to build a profile of"
                          }
                        )
                      ] })
                    ] })
                  ] })
                ]
              }
            ) })
          }
        )
      ]
    }
  );
}
export {
  o as CookieSetting,
  J as CookieSettingStoryWrapper
};
